import { motion } from "framer-motion";
import { useState } from "react";

const InputField = ({
  type,
  placeholder,
  value,
  onChange,
  error,
  onBlur,
  name,
}) => {
  const [isFocused, setIsFocused] = useState(false);

  return (
    <div className="input-container">
      <motion.input
        type={type}
        placeholder={placeholder}
        value={value}
        onChange={onChange}
        onBlur={(e) => {
          setIsFocused(false);
          onBlur && onBlur(e);
        }}
        onFocus={() => setIsFocused(true)}
        name={name}
        className={`input-field ${error ? "error" : ""}`}
        initial={{ scale: 1 }}
        animate={{
          scale: isFocused ? 1.02 : 1,
          borderColor: isFocused ? "#4f46e5" : error ? "#ef4444" : "#e5e7eb",
          boxShadow: isFocused ? "0 0 0 2px rgba(79, 70, 229, 0.2)" : "none",
        }}
        transition={{ duration: 0.2 }}
      />
      {error && (
        <motion.p
          className="error-message"
          initial={{ opacity: 0, y: -10 }}
          animate={{ opacity: 1, y: 0 }}
          exit={{ opacity: 0, y: -10 }}
        >
          {error}
        </motion.p>
      )}
    </div>
  );
};

export default InputField;
